export enum AdminPathEnum {
  users = 'users',
  processus = 'processus',
  societePatrimoineHierarchie = 'societe-patrimoine-hierarchie',
  societeEspaceFamilles = 'societe-espace-familles',
  societeEspaces = 'societe-espaces',
  societeComposantFamilles = 'societe-composants-familles',
  societeComposants = 'societe-composants',
  societeCaracteristiquesComposants = 'societe-caracteristique-composants',
  societeCaracteristiquesPatrimoines = 'societe-caracteristique-patrimoines',
  societeTerritoires = 'societe-territoires',
  societeTerritoiresPatrimoines = 'societe-territoires-patrimoines',
  societeProfils = 'societe-profils',
  societeUsersPatrimoines = 'societe-users-patrimoines',
  import = 'import',
  configuration = 'configuration-get-and-share',
  composantTemplate = 'composant-template',
  caracteristiqueTemplate = 'caracteristique-template',
  patrimoineHierarchieTemplate = 'patrimoine-hierarchie-template',
  societeCreation = 'societe-creation',
  adminGlobal = 'admin-global',
  deletion = 'deletion',
  newsletter = 'newsletter',
  patrimoines = 'patrimoines'
}
